import type * as React from 'react';

import type { BlockProps } from '@gitbook/slate-react';
import { CodeBlockLine } from '@gitbook/spine-react';

/**
 * Renderer for a line in a code block.
 */
export function BlockCodeLine(props: BlockProps): React.ReactElement {
    const { node, parent, children, editor, domRef, attributes } = props;
    const { diff, highlighted } = node.data.toFrozenObject();

    const highlighting = ['added', 'deleted', 'modified'].includes(diff)
        ? diff
        : highlighted
          ? 'highlighted'
          : undefined;

    const onHighlight = () => {
        editor.change((change) => {
            change.setDataByKey(node.key, ['highlighted'], !highlighted);
        });
    };

    return (
        <CodeBlockLine
            {...attributes}
            ref={domRef}
            highlighting={highlighting}
            number={parent.getChildIndex(node.key) + 1}
            onSelect={editor.readOnly ? undefined : onHighlight}
        >
            {children}
        </CodeBlockLine>
    );
}
